// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            $('body').addClass('activeMenu');
        });

        $(document).on('click', '.closeMenu', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        if ($('.homeProd__slider').length) {
            const homeProdSlider = new Swiper('.homeProd__slider', {
                slidesPerView: 5,
                spaceBetween: 0,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                navigation: false,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 5,
                        spaceBetween: 8
                    }
                }
            });
        }

        if ($('.homeUses__mobile').length) {
            const homeApp = new Swiper('.homeUses__mobile', {
                slidesPerView: 3,
                spaceBetween: 8,
                navigation: false,
                pagination: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 8
                    }
                }
            });
        }

        if ($('.aboutHistory__slider').length) {
            const aboutHistory__times = new Swiper(".aboutHistory__times", {
                spaceBetween: 10,
                slidesPerView: 8,
                freeMode: true,
                watchSlidesProgress: true,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 6,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 10,
                        spaceBetween: 8
                    }
                }
            });
            const aboutHistory__slider = new Swiper(".aboutHistory__slider", {
                spaceBetween: 24,
                parallax: true,
                speed: 1000,
                navigation: {
                    nextEl: ".aboutHistory__wrap .timeBtn--next",
                    prevEl: ".aboutHistory__wrap .timeBtn--prev",
                },
                thumbs: {
                    swiper: aboutHistory__times,
                },
            });
        }

        if ($('.aboutEnv__slider').length) {
            const aboutEnv__slider = new Swiper('.aboutEnv__slider', {
                slidesPerView: 4,
                spaceBetween: 30,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                navigation: false,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.3,
                        spaceBetween: 10
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.3,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 12
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }
                }
            });
        }
        if ($('.productSummary__images').length) {
            const prodThumbs = new Swiper('.productSummary__thumbs', {
                slidesPerView: "auto",
                spaceBetween: 6,
                direction: "vertical",
                // loop: true,
                autoplay: false,
                speed: 500,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".productSummary__thumbWrap .swiper-button-next",
                    prevEl: ".productSummary__thumbWrap .swiper-button-prev",
                },
            });
            const prodImages = new Swiper('.productSummary__images', {
                // loop: true,
                autoplay: false,
                spaceBetween: 12,
                // effect: 'fade',
                speed: 500,
                thumbs: {
                    swiper: prodThumbs,
                },
            });
        }
        $(window).on('scroll', function () {
            if ($('.process .figureNumber').length) {
                $('.process .figureNumber').each(function () {
                    var $this = $(this);
                    var position = $this.offset().top;
                    var scrollPosition = $(window).scrollTop() + $(window).height();
                    // Chạy khi phần tử xuất hiện trong màn hình
                    if (position < scrollPosition) {
                        runCounter($this);
                    }
                });
            }
        });

        function runCounter($element) {
            if (!$element.hasClass("counted")) {
                var numberString = $element.html();
                var cleanedNumberString = numberString.replace(/\./g, '');
                var targetNumber = parseInt(cleanedNumberString, 10);

                if (!isNaN(targetNumber)) {
                    $element.addClass("counted");
                    $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                        duration: 3000,
                        easing: "linear",
                        step: function () {
                            let currentNum = Math.floor(this.countNum);
                            let formattedNum = currentNum.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedNum);
                        },
                        complete: function () {
                            let formattedTarget = targetNumber.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedTarget);
                        }
                    });
                } else {
                    console.error("Lỗi: Không thể chuyển đổi '" + numberString + "' thành số hợp lệ.");
                }
            }
        }

        setTimeout(function () {
            AOS.init({ disable: 'mobile', once: true });

            if ($('.sf-field-search .sf-input-text').length) {
                $('.sf-field-search .sf-input-text').addClass('form-control');
            }
            if ($('.sf-field-sort_order .sf-input-select').length) {
                $('.sf-field-sort_order .sf-input-select').addClass('form-select');
            }
        }, 500);

        $('#modalBuy').on('show.bs.modal', function() {
            let title = $('.productSummary__title').text();
            if($('input[name="product-name"]').length) {
                $('input[name="product-name"]').val(title);
            }
        });

    });

    window.addEventListener('load', () => {
        const marqueeContainer = document.getElementById('myMarquee');
        if (!marqueeContainer) {
            console.error("Marquee container '#myMarquee' not found.");
            return;
        }

        const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
        if (!marqueeWrapper) {
            console.error("Marquee wrapper '.marqueeContainer' not found inside '#myMarquee'.");
            return;
        }

        const originalItems = Array.from(marqueeWrapper.children);
        if (originalItems.length === 0) {
            console.warn("Marquee wrapper has no child elements.");
            return; // No items to animate
        }

        // --- Configuration ---
        const speed = 80; // pixels per second
        const direction = -1; // -1: Left, 1: Right (Current logic best supports -1)
        let pauseOnHover = true;

        // --- Clone items ---
        // Clear existing clones if the script runs again (e.g., in development)
        while (marqueeWrapper.children.length > originalItems.length) {
            marqueeWrapper.removeChild(marqueeWrapper.lastChild);
        }
        // Clone
        originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            // Optional: Add a class or attribute to identify clones for debugging
            // clone.setAttribute('data-clone', 'true');
            marqueeWrapper.appendChild(clone);
        });

        // --- Calculate width and duration based on actual rendered width ---
        // Ensure styles are applied and layout is calculated
        // requestAnimationFrame can help ensure layout is stable before measuring
        requestAnimationFrame(() => {
            // Measure the total width of the wrapper containing original + clones
            const totalWidth = marqueeWrapper.scrollWidth;

            // The width needed for one cycle is half of the total width
            const resetWidth = totalWidth / 2;

            // If calculated width is zero or container is not wide enough for scrolling, stop.
            if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                // console.warn("Marquee content is not wide enough to scroll or width calculation failed.");
                // Optionally remove clones if not scrolling
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
                return;
            }

            // Calculate duration
            const duration = (speed > 0) ? (resetWidth / speed) * 1000 : 0; // in ms

            // Cancel any previous animation on the wrapper
            if (marqueeWrapper.animation) {
                marqueeWrapper.animation.cancel();
            }

            // --- Create Animation using WAAPI ---
            if (duration > 0) {
                const animation = marqueeWrapper.animate(
                    [
                        { transform: `translateX(25px)` },
                        { transform: `translateX(${direction * resetWidth}px)` }
                    ],
                    {
                        duration: duration,
                        iterations: Infinity,
                        easing: 'linear'
                    }
                );

                // Store the animation object
                marqueeWrapper.animation = animation;

                // --- Handle Pause/Play on Hover ---
                if (pauseOnHover) {
                    // Use variables to store bound functions for easy removal later if needed
                    const pauseAnimation = () => marqueeWrapper.animation?.pause();
                    const playAnimation = () => marqueeWrapper.animation?.play();

                    marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                    marqueeContainer.addEventListener('mouseleave', playAnimation);

                    // Optional: Store listeners for potential cleanup
                    marqueeContainer.animationListeners = { pauseAnimation, playAnimation };
                }
            } else {
                // If duration is 0, ensure clones are removed if they were added
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
            }
        }); // End of requestAnimationFrame

    });

})(jQuery)